'use strict';

(function (/** @type {import('jquery')} */$) {
	if (!$) {
		return false;
	}

	const NAME_SPACE = 'Media_Player';
	const STATUS = {
		READY: 1,
		PLAYING: 2,
		PAUSE: 3,
		ENDED: 4,
	};
	const getFullscreenElement = () => (document.fullscreenElement || document.webkitFullscreenElement);
	const isMobileBowser = /(iphone|ipad|android)/i.test(window.navigator.userAgent);
	/** @type {VideoPlayer} */
	let PlayeringInstance = null;

	$(document).on('fullscreenchange  webkitfullscreenchange', () => {
		if (!getFullscreenElement() && PlayeringInstance && PlayeringInstance.stop) {
			PlayeringInstance.stop();
		}
	});

	class VideoPlayer {
		/**
		 * @param {HTMLVideoElement} video
		 */
		constructor(video, options) {
			const $video = $(video);
			const dataset = video.dataset;
			const src = video.src || dataset.src;
			const poster = video.poster || dataset.poster;
			const data = {
				isUpload: false,
				type: video.tagName,
				src,
				poster,
				width: Number(dataset.width),
				height: Number(dataset.height),
				maxWidth: options.maxWidth === 'parent' ? $video.parent().innerWidth() : options.maxWidth,
				minWidth: options.minWidth,
				maxHeight: options.maxHeight,
				minHeight: options.minHeight,
				canPlay: false,
			};

			this.data = data;
			this.video = video;
			this.$video = $video;
			this.status = STATUS.READY;

			['controls'].forEach((attrName) => {
				video.removeAttribute(attrName);
			});
			// video.setAttribute('playsinline', 'playsinline');
			video.setAttribute('tabindex', '-1');

			// wrapper
			$video.wrap('<div class="media-player"></div>');
			const $wrap = $video.parent();
			this.$wrap = $wrap;
			$wrap.attr('status', this.status);

			// poster
			if (data.poster) {
				const $img = $(`<img class="video-poster" src="${data.poster}" />`);
				this.$poster = $img;
				$img.appendTo($wrap);
			}

			// icon
			const $icon = $('<div class="action"><i class="fa fa-play" /></div>');
			this.$icon = $icon;
			$icon.appendTo($wrap);

			this.setSize(data.width, data.height);
			const hasUploadProp = typeof options.isUpload === 'boolean';
			if (hasUploadProp) {
				this.isUpload(options.isUpload);
			}

			// bind event
			$wrap.on('click', (e) => {
				e.stopPropagation();
				if ([STATUS.READY, STATUS.PAUSE, STATUS.ENDED].indexOf(this.status) !== -1) {
					this.play();
				} else if (this.status === STATUS.PLAYING) {
					this.stop();
				}
				return false;
			});

			// video event
			$video.on('loadeddata', () => {
				// console.log('=====> loadeddata');
				this.status = STATUS.READY;
				$wrap.attr('status', this.status).removeClass('playing');
				this.setSize(video.videoWidth, video.videoHeight);
			});
			$video.on('durationchange', () => {
				// console.log('=====> durationchange');
			});
			$video.on('canplay', () => {
				// console.log('=====> canplay');
				this.data.canPlay = true;
				$wrap.attr('status', this.status);
			});
			$video.on('play', () => {
				// console.log('=====> play');
			});
			$video.on('playing', () => {
				// console.log('=====> playing');
				this.status = STATUS.PLAYING;
				$wrap.attr('status', this.status).addClass('playing');
				if (this.$poster) {
					this.$poster.hide();
				}
				if (!hasUploadProp) {
					this.isLoading(false);
				}
			});
			$video.on('pause', () => {
				// console.log('=====> pause');
				this.status = STATUS.PAUSE;
				$wrap.attr('status', this.status).removeClass('playing');
			});
			$video.on('ended', () => {
				// console.log('=====> ended');
				this.status = STATUS.ENDED;
				$wrap.attr('status', this.status).removeClass('playing');
			});
		}

		play() {
			if (PlayeringInstance) {
				PlayeringInstance.stop();
			}
			PlayeringInstance = this;
			if (!this.video.src) {
				this.video.src = this.data.src;
			}
			this.isLoading(true);
			this.video.play();
			if (isMobileBowser) {
				this.fullscreen();
			}
		}

		stop() {
			this.video.pause();
		}

		fullscreen() {
			if (!getFullscreenElement()) {
				if (this.video.requestFullscreen) {
					this.video.requestFullscreen();
				} else if (this.video.webkitRequestFullScreen) {
					this.video.webkitRequestFullScreen();
				}
			}
		}

		isLoading(status) {
			this.isUpload(status);
		}

		isUpload(status) {
			const hasParam = typeof status === 'boolean';
			if (status === true || (!hasParam && !this.data.isUpload)) {
				this.data.isUpload = true;
				this.$icon.find('.fa')[0].className = 'fa fa-spin fa-circle-o-notch';
				this.$wrap.addClass('isUpload');
			} else if (status === false || (!hasParam && this.data.isUpload)) {
				this.data.isUpload = false;
				this.$icon.find('.fa')[0].className = 'fa fa-play';
				this.$wrap.removeClass('isUpload');
			}
		}

		setSize(width, height) {
			if (width && height) {
				this.data.width = width;
				this.data.height = height;

				if (!(this.data.maxWidth || this.data.maxHeight)) {
					this.$wrap.css({
						'max-width': `${this.data.maxWidth || width}px`,
						'max-height': `${this.data.maxHeight || height}px`,
					});
				} else {
					const style = {
						width: width || '',
						height: height || '',
					};

					if (this.data.maxWidth) {
						if (style.width > this.data.maxWidth) {
							style.height *= this.data.maxWidth / style.width;
							style.width = this.data.maxWidth;
						}
					}

					if (this.data.maxHeight) {
						if (style.height > this.data.maxHeight) {
							style.width *= this.data.maxHeight / style.height;
							style.height = this.data.maxHeight;
						}
					}

					if (this.data.minHeight) {
						if (style.height < this.data.minHeight) {
							style.width *= this.data.minHeight / style.height;
							style.height = this.data.minHeight;
						}
					}

					this.$wrap.css(style);
					this.$poster.css(style);
					$(this.video).css(style);
				}
			}
		}

		value(options) {
			if (options) {
				const { poster, src } = options;
				if (src) {
					this.video.src = src;
					this.data.src = src;
				}
				if (poster) {
					this.data.poster = poster;
					this.video.poster = poster;
					this.$poster.attr('src', poster);
				}
			} else {
				return this.data;
			}
		}
	}

	if (!$.fn.videoPlayer) {
		$.fn.videoPlayer = function (options) {
			const instance = this.data(NAME_SPACE);

			if (!instance) {
				return this.each(function (idx, i) {
					const ins = $(i).data(NAME_SPACE);
					if (ins) {
						return ins;
					} else if (i.tagName === 'VIDEO') {
						return $(i).data(NAME_SPACE, new VideoPlayer(i, options || {}));
					}
					// throw new Error('[videoPlayer] target is not a video object.');
				});
			} else if (arguments && arguments[0] === true) {
				return instance;
			}
		};
	}
}(window.$));
